import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"pix-block {{concat \"pix-block--\" this.variant}}{{if @condensed \" pix-block--condensed\"}}\" ...attributes>\n\n  {{yield}}\n\n</div>", {
  moduleName: "@1024pix/pix-ui/components/pix-block.hbs"
});